"use client";
import React, { Dispatch } from "react";
import {FrameBody, Updater, UpdaterContainerProps } from "@npd-ng/adp-benchmark";
import { useIPCBridge } from "../hooks/useIPCBridge";
import { IADPState } from "../types";
import { IADPActions } from "../state/Actions";
import { useStateContext } from "../hooks/useStateContext";
let updateInProgress = false;
export default function UpdateView() {
  const { state, dispatch } = useStateContext();
  const {checkForUpdates} = useIPCBridge(dispatch,state);
  const notifications = state.staticContent?.notifications
  const getUpdateProps = ():UpdaterContainerProps=>{
    if(state.updateState.updateEvents?.type === "update-available"){
      return {
        title: notifications?.updatesAvailableTitle as string,
        subTitle: notifications?.updateStart as string,
        progress: {
          variant: "info",
          level: 1
        },
        message: notifications?.updatesEstimatedTimeText as string,
        type: "info"
      }
    }
    else if(state.updateState.updateEvents?.type ==="download-progress"){
      return {
        title: notifications?.updatesAvailableTitle as string,
        subTitle: notifications?.updateDownload as string,
        progress: {
          variant: "warning",
          level: state.updateState.updateEvents?.message?.level as number
        },
        message: `${notifications?.updatesEstimatedTimeText} <br/> ${notifications?.wait}`,
        type: "progress"
      }
    }
    else if(state.updateState.updateEvents?.type ==="install-progress"){
      return {
        title: notifications?.updatesReadyTitle as string,
        subTitle: notifications?.updateInstall as string,
        progress: {
          variant: state.updateState.updateEvents?.message?.level === 100 ? "success" : "info",
          level: state.updateState.updateEvents?.message?.level
        },
        message: `${notifications?.updatesEstimatedTimeText} <br/> ${notifications?.wait}`,
        type: "progress"
      }
    }
    else if(state.updateState.updateEvents?.type ==="prepare-for-update"){
      return {
        title: notifications?.updatePrep as string,
        subTitle: `${notifications?.updatesEstimatedTimeText} <br/> ${notifications?.wait}` as string,
        progress: {
          variant: "info",
          level: 0
        },
        message:  state.updateState.updateEvents?.message?.progress.toString(),
        type: "wait"
      }
    }
    else if(state.updateState.updateEvents?.type ==="update-complete"){
      return {
        title: notifications?.updatesReadyTitle as string,
        subTitle: notifications?.restartInfo as string,
        progress: {
          variant: "success",
          level: 100
        },
        message: notifications?.doNotCloseAppWarn as string,
        type: "info"
      }
    }
    else if(state.updateState.updateEvents?.type ==="update-ready"){
      return {
        title: notifications?.updatesReadyTitle as string,
        subTitle: notifications?.updateInstall as string,
        progress: {
          variant: "info",
          level: 0
        },
        message: notifications?.doNotCloseAppWarn as string,
        type: "progress"
      }
    }
    else if(state.updateState.updateEvents?.type ==="update-not-available"){
      return {
        title: notifications?.updateNotFoundTitle as string,
        subTitle: notifications?.updateNotFoundSubTitle as string,
        progress: {
          variant: "success",
          level: 0
        },
        message: notifications?.updateNotFoundSubTitle as string,
        type: "info"
      }
    }
    else {
      return {
        title: notifications?.updateChecking as string,
        subTitle: notifications?.wait as string,
        progress: {
          variant: "success",
          level: 0
        },
        message: "",
        type: "wait"
      }
    }
  }
  React.useEffect(() => {
    if(updateInProgress)return;
        updateInProgress = true
        checkForUpdates();
  }, []);
  return (
    <FrameBody>
        <Updater {...getUpdateProps()} />
    </FrameBody>
  );
}
